import * as Sentry from '@sentry/browser'
import { defineStore } from 'pinia'
import { Service } from '@/services/helpers/ServiceHelper'

type Post = {
  id: number
  title: string
  description: string
  date: string
  link: string
  icon: string
}

export const useNewFeaturesStore = defineStore('newFeatures', () => {
  const posts = ref<Array<Post>>([])
  const latestTimestamp = ref<string | null>(null)
  const lastSeenTimestamp = ref<string | null>(localStorage.getItem('lastSeenNewFeaturesTimestamp'))
  const snackbar = useSnackbar()

  const hasNewFeatures = computed(() => {
    if (!latestTimestamp.value) { return false }
    if (!lastSeenTimestamp.value) { return true }
    return new Date(latestTimestamp.value) > new Date(lastSeenTimestamp.value)
  })

  const fetchFeatures = async () => {
    try {
      const { getEffectiveAuthToken } = useEffectiveAuthToken()
      if (!await getEffectiveAuthToken()) { return [] }
      const { posts: fetchedPosts, timestamp } = await Service.api.newFeaturesService?.getFeatures()
      posts.value = fetchedPosts
      latestTimestamp.value = timestamp
      return posts.value
    } catch (error) {
      snackbar.error('Failed to load new posts.')
      Sentry.captureException(error)
      return []
    }
  }

  const markFeaturesAsSeen = () => {
    if (!latestTimestamp.value) { return }
    lastSeenTimestamp.value = latestTimestamp.value
    localStorage.setItem('lastSeenNewFeaturesTimestamp', latestTimestamp.value)
  }

  return {
    readable: {
      posts,
      hasNewFeatures
    },
    fetchFeatures,
    markFeaturesAsSeen
  }
})
